import { kRoomPrefixes } from "./rules";
export function dateIso(d) {
    return [
        d.getFullYear(),
        ('0' + (d.getMonth() + 1)).slice(-2),
        ('0' + d.getDate()).slice(-2)
    ].join('-');
}
export function isUserAdmin(user) {
    return user.email.endsWith('@andoverrobotics.com');
}
export function toAndoverTime(date) {
    return new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));
}
export function sameDayAtAndover(date1, date2) {
    const [et1, et2] = [date1, date2].map(toAndoverTime);
    return et1.getFullYear() === et2.getFullYear() && et1.getMonth() === et2.getMonth() && et1.getDate() === et2.getDate();
}
export function validInputStrings(vals) {
    const valid = (str) => str !== null && str.trim().length > 0;
    return vals.every(valid);
}
export function getItemById(items, id) {
    return items.find(it => it.id === id) ?? null;
}
export function meetingSeatAssignments(meet) {
    if (meet == null)
        return {};
    return Object.fromEntries(meet.attendees.map(it => [it.seat, it.identity]));
}
export function externalSeat(meet, room) {
    const numExisting = meet.attendees.map(it => it.seat).filter(seat => seat.startsWith(kRoomPrefixes[room])).length;
    return kRoomPrefixes[room] + (numExisting + 1).toString();
}
